import { Icon, type IconProps } from "../icon";

const PATHS = [
  "m14.276 23.61 6.667-6.667a1.33 1.33 0 0 0 0-1.885L14.276 8.39a1.33 1.33 0 0 0-1.885 0 1.33 1.33 0 0 0 0 1.885L18.115 16l-5.724 5.724a1.332 1.332 0 1 0 1.885 1.886",
];

export function ArrowRightIcon(props: IconProps) {
  return <Icon paths={PATHS} {...props} />;
}
